import { inject, Injectable } from '@angular/core';
import { FeatureFlagsService } from '@hub-services/feature-flags.service';

@Injectable({
  providedIn: 'root'
})
export class BundlesGuard  {
  canActivate(): boolean {
    return inject(FeatureFlagsService).getFeatureFlag('bundles');
  }
}
